<template>
  <v-btn
    icon
    :large="$vuetify.breakpoint.lgAndUp"
    :color="color"
    @click="$emit('click')"
  >
    <v-icon>
      {{ icon }}
    </v-icon>
  </v-btn>
</template>

<script>
  export default {
    name: 'GamepadButton',

    props: {
      color: String,
      icon: String,
    },

  }
</script>
